import React from 'react'
import { connect } from 'react-redux'
import { CREATE_FOLDER_MODAL } from '@chegg-wt/core/state/modals/constants'
import { addFolder } from '@chegg-wt/core/state/folders/actions'
import { Folder } from '@chegg-wt/core/types/folders'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { BaseModalProps } from '../BaseModal'
import { Modal } from '..'
import FolderModalBase from './FolderModalBase'

interface CreateFolderModalProps extends BaseModalProps {
  // TODO: refactor index out
  handleConfirm: (index: number, folder: Folder) => void
}

const CreateFolderModal: React.FunctionComponent<CreateFolderModalProps> = ({
  handleConfirm,
  handleClose,
}) => (
  <Modal showModal closeButton outsideClick>
    <FolderModalBase
      title="Create folder"
      handleConfirm={handleConfirm}
      handleClose={handleClose}
      confirmCTAText="Create"
    />
  </Modal>
)

const mapDispatchToProps = {
  handleConfirm: (_, folder) => addFolder(folder),
  handleClose: () => closeModal(CREATE_FOLDER_MODAL),
}

export default connect(null, mapDispatchToProps)(CreateFolderModal)
